import { Routes } from '@angular/router';
import { OktaCallbackComponent, canActivateAuthGuard } from '@okta/okta-angular';
import { DefaultLayoutComponent } from './containers';
import { authGuard } from './guards/auth.guard';
import { operatorOkGuard } from './guards/operator-ok.guard';
import { LoginComponent } from './components/login/login.component';
import { environment } from '../environments/environment';

const sessionGuards = environment.useSSO ? [canActivateAuthGuard] : [authGuard];

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  ...(environment.useSSO ? [{ path: 'callback', component: OktaCallbackComponent }] : []),
  {
    path: 'operario-no-configurado',
    loadComponent: () =>
      import('./components/operator-not-configured/operator-not-configured.component')
        .then(m => m.OperatorNotConfiguredComponent),
    canActivate: sessionGuards
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [...sessionGuards, operatorOkGuard],
    children: [
      { path: '', redirectTo: 'planner', pathMatch: 'full' },
      {
        path: 'planner',
        loadChildren: () =>
          import('./components/planner/planner.routes').then(m => m.plannerRoutes)
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./components/warehouse/warehouse.routes').then(m => m.warehouseRoutes)
      },
      {
        path: 'appointment',
        loadChildren: () =>
          import('./components/appointment/appointment.routes').then(m => m.appointmentRoutes)
      },
      {
        path: 'quality-control',
        loadChildren: () =>
          import('./components/quality-control/quality-control.routes').then(m => m.qualityControlRoutes)
      },
      {
        path: 'operations',
        loadChildren: () =>
          import('./components/operations/operations.routes').then(m => m.operationsRoutes)
      },
      {
        path: 'configurator',
        loadChildren: () =>
          import('./components/configurator/configurator.routes').then(m => m.configuratorRoutes)
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./components/admin/admin.routes').then(m => m.adminRoutes)
      }
    ]
  },
  { path: '**', redirectTo: environment.useSSO ? 'planner' : 'login' }
];
